import React from 'react'

import Map2015 from '-!svg-react-loader!../../../img/svg/map-msg-prioritized-states-2015.svg'

const MsgPrioritizedStatesSvg = props => (
  <Map2015 />
)

export default MsgPrioritizedStatesSvg
